import React, { useState, useEffect } from 'react';
import '../styles/Laboratory.css';
import pic1 from "../assets/bio.png";
import pic2 from "../assets/phy.png";
import pic3 from "../assets/agri.png";
import pic4 from "../assets/che.png";
import pic5 from "../assets/geography (1).png";
import pic6 from "../assets/comp.png";
import pic7 from "../sciencelabs/biologya (1).webp";
import pic8 from "../sciencelabs/biologya (2).webp";
import pic9 from "../sciencelabs/biology (3).webp";
import pic10 from "../sciencelabs/agriculture (3).webp";
import pic11 from "../sciencelabs/agriculture (3).webp";
import pic12 from "../sciencelabs/agriculture (3).webp";
import pic13 from "../sciencelabs/computer (1).webp";
import pic14 from "../sciencelabs/computer (2).webp";
import pic15 from "../sciencelabs/computer (3).webp";
import pic16 from "../sciencelabs/chemistry (1).webp";
import pic17 from "../sciencelabs/chemistry (2).webp";
import pic18 from "../sciencelabs/chemistry (3).webp";
import pic19 from "../sciencelabs/physics (1).webp";
import pic20 from "../sciencelabs/physics (2).webp";
import pic21 from "../sciencelabs/physics (3).webp";
import pic22 from "../sciencelabs/geography (1).webp";
import pic23 from "../sciencelabs/geography (2).webp";
import pic24 from "../sciencelabs/geography (1).webp";

const Laboratory = () => {

  const [isVisible, setIsVisible] = useState(false);
  
    useEffect(() => {
      setIsVisible(true);
    }, []);

  const [currentSlides, setCurrentSlides] = useState({
    biology: 0,
    physics: 0,
    agri: 0,
    chemistry: 0,
    geography: 0,
    computer: 0,
  });

  const [autoPlay, setAutoPlay] = useState({
    biology: true,
    physics: true,
    agri: true,
    chemistry: true,
    geography: true,
    computer: true,
  });

  // Laboratory data with images
  const laboratories = [
    {
      id: 'biology',
      name: 'Biology Laboratory',
      description: 'Our state-of-the-art Biology Laboratory is a premier facility designed for comprehensive study of living organisms and cellular structures. Equipped with advanced compound microscopes, digital microscopy systems, and dissection kits, students can observe cellular components, tissues, and organs in detail. The laboratory houses extensive specimen collections including preserved organisms, skeletal models, and biological samples for hands-on learning. Students conduct experiments on photosynthesis, respiration, enzyme activity, and genetic inheritance using modern equipment. The facility supports inquiry-based learning with wet lab setups for culturing microorganisms and cell biology investigations. Safety protocols and proper handling procedures are strictly maintained with fume hoods and proper ventilation systems. Dedicated storage areas preserve biological specimens in optimal conditions for long-term educational use. Students learn proper microscopy techniques, specimen preparation, and scientific observation methodologies. The lab encourages collaborative research projects and supports both Class XII board practical examinations and advanced academic investigations. An experienced lab technician ensures equipment maintenance and safety compliance for all experiments.',
      icon: pic1,
      images: [
         pic7,
         pic8,
         pic9,
      ],
      order: 'left'
    },
    {
      id: 'physics',
      name: 'Physics Laboratory',
      description: 'The Physics Laboratory represents excellence in experimental science education with cutting-edge equipment for studying fundamental natural phenomena. The facility contains precision instruments for mechanics experiments including spring constants, simple harmonic motion, and Newton\'s laws verification through carefully calibrated apparatus. Electricity and magnetism section features equipments for studying circuits, electromagnetic induction, and magnetic field patterns using data logging systems. The optics unit provides extensive optical benches with lenses, prisms, diffraction gratings, and spectrophotometers for light behavior investigations. Modern digital multimeters, oscilloscopes, and signal generators enable advanced electronics and wave studies with real-time data visualization. Thermal experiments utilize precise thermometers, calorimeters, and temperature sensors for heat transfer and thermodynamic studies. The laboratory supports nuclear physics concepts through simulation software since actual radioactive materials are not used. Students develop experimental design skills, error analysis techniques, and scientific report writing through systematic investigations. Data collection and analysis use computer-based systems allowing direct measurement integration and graphical interpretation. Regular equipment maintenance and calibration ensure accurate experimental results and reliable learning outcomes for all students.',
      icon: pic2,
      images: [
       pic19,
       pic20,
       pic21,
      ],
      order: 'right'
    },
    {
      id: 'agri',
      name: 'Agricultural Science Laboratory',
      description: 'The Agricultural Science Laboratory serves as a specialized research and teaching facility dedicated to advancing agricultural knowledge and sustainable farming practices. Soil analysis section equipped with soil testing kits, pH meters, and nutrient analysis equipment for comprehensive soil characterization and fertility assessment. The facility provides seed quality testing apparatus including germination chambers, moisture meters, and vigour testing equipment for seed certification standards. Students conduct detailed microscopic analysis of plant tissues, pollen structures, and fungal identification using compound microscopes and prepared slides. Microbiology section includes culture media preparation facilities, incubators, and sterilization equipment for studying beneficial and pathogenic microorganisms. Plant propagation facilities with controlled temperature and humidity chambers support tissue culture and plant breeding experiments. The laboratory maintains collections of crop samples, pest specimens, and disease-infected plant materials for identification and management training. Students learn integrated pest management, organic farming principles, and sustainable agricultural technologies through practical demonstrations. Chemical analysis equipment determines macronutrient and micronutrient levels in soil and plant tissues using standard protocols. The facility collaborates with agricultural extension services providing students exposure to real farming challenges and modern agribusiness practices.',
      icon: pic3,
      images: [
        pic10,
        pic12,
        pic11,
      ],
      order: 'left'
    },
    {
      id: 'chemistry',
      name: 'Chemistry Laboratory',
      description: 'The Chemistry Laboratory is a world-class facility designed for safe and comprehensive chemical education spanning inorganic, organic, analytical, and physical chemistry domains. The laboratory features properly installed fume hoods with efficient ventilation systems ensuring safe handling of toxic and corrosive chemicals with minimal environmental impact. Extensive glassware collection includes graduated cylinders, flasks, burettes, and pipettes calibrated to precise measurement standards required for accurate titrations and quantitative analysis. Analytical instruments such as colorimeters, conductivity meters, and pH meters enable students to perform quantitative chemical analysis with modern precision equipment. Organic chemistry section provides facilities for distillation, crystallization, and separation techniques with proper heating and cooling apparatus for practical synthesis experiments. Safety equipment including emergency eyewash stations, safety showers, and spill kits are strategically positioned throughout the laboratory. Chemical storage facilities maintain proper segregation of incompatible substances in clearly labeled containers following safety data sheet protocols. Students practice proper safety procedures including chemical handling, waste disposal, and emergency response as part of practical training. The laboratory supports board examination practicals and research projects with equipment for pH determination, standardization of solutions, and complex chemical reactions. Trained laboratory staff supervise all experiments ensuring compliance with safety standards and proper laboratory practices.',
      icon: pic4,
      images: [
        pic17,
        pic16,
        pic18,
      ],
      order: 'right'
    },
    {
      id: 'geography',
      name: 'Geography Laboratory',
      description: 'The Geography Laboratory is a comprehensive facility dedicated to the study of Earth\'s physical features, human populations, and their complex interactions. Equipped with modern mapping technologies and geographic information systems (GIS), students learn spatial analysis and geospatial data interpretation skills essential for contemporary geography. The laboratory houses extensive map collections including topographical maps, thematic maps, and digital atlases covering various scales and regions. Weather monitoring stations with anemometers, barometers, and thermometers enable students to conduct meteorological experiments and understand atmospheric phenomena. Rock and mineral specimen collections provide hands-on learning experiences in geology and mineralogy with magnifying glasses and identification keys. Soil profile display cases and sediment samples support pedology studies and understanding soil formation processes. The facility features interactive globe models, 3D terrain models, and relief maps for understanding landform patterns and tectonic features. Students engage in fieldwork preparation and data collection techniques using GPS devices and surveying instruments. The laboratory supports environmental geography projects with water quality testing kits and pollution monitoring equipment. Study materials on population patterns, economic activities, and cultural geographies provide comprehensive global perspectives. A trained geography specialist maintains the laboratory ensuring proper specimen preservation and equipment calibration for accurate geographical learning.',
      icon: pic5,
      images: [
        pic22,
        pic23,
        pic24,
      ],
      order: 'left'
    },
    {
      id: 'computer',
      name: 'Computer Science Laboratory',
      description: 'The Computer Science Laboratory represents a fully networked, modern computing facility equipped with latest technologies supporting comprehensive IT education and digital skills development. High-performance workstations with multi-core processors and adequate RAM enable smooth operation of programming IDEs, design software, and data analysis applications required for coursework. Reliable high-speed internet connectivity through fiber optic connections ensures seamless access to online resources, coding platforms, and cloud-based development environments. Updated software suite includes programming languages like Python, C++, and Java with industry-standard development tools like Visual Studio Code and JetBrains IDEs. Web development facilities provide platforms for learning HTML, CSS, JavaScript, and backend frameworks with local server setup capabilities for full-stack development. Database management systems including MySQL and MongoDB are installed enabling students to practice database design, querying, and optimization. Dedicated cybersecurity stations teach network concepts, encryption principles, and ethical hacking through controlled sandboxed environments. Graphics and multimedia labs support image editing, video processing, and animation using professional software like Adobe Creative Suite. Linux and Windows operating systems are available in dual-boot configuration exposing students to various computing environments. The laboratory supports competitive programming preparation, internship readiness, and advanced projects equipping students for technology careers.',
      icon: pic6,
      images: [
        pic15,
        pic13,
        pic14,
      ],
      order: 'right'
    }
  ];

  // Auto-play for each lab
  useEffect(() => {
    const intervals = {};

    Object.keys(currentSlides).forEach((labId) => {
      if (!autoPlay[labId]) return;

      intervals[labId] = setInterval(() => {
        setCurrentSlides((prev) => {
          const lab = laboratories.find(l => l.id === labId);
          return {
            ...prev,
            [labId]: (prev[labId] + 1) % lab.images.length
          };
        });
      }, 5000);
    });

    return () => {
      Object.values(intervals).forEach(interval => clearInterval(interval));
    };
  }, [autoPlay, laboratories]);

  const nextSlide = (labId, totalImages) => {
    setAutoPlay(prev => ({ ...prev, [labId]: false }));
    setCurrentSlides(prev => ({
      ...prev,
      [labId]: (prev[labId] + 1) % totalImages
    }));
    setTimeout(() => setAutoPlay(prev => ({ ...prev, [labId]: true })), 5000);
  };

  const prevSlide = (labId, totalImages) => {
    setAutoPlay(prev => ({ ...prev, [labId]: false }));
    setCurrentSlides(prev => ({
      ...prev,
      [labId]: (prev[labId] - 1 + totalImages) % totalImages
    }));
    setTimeout(() => setAutoPlay(prev => ({ ...prev, [labId]: true })), 5000);
  };

  const goToSlide = (labId, index) => {
    setAutoPlay(prev => ({ ...prev, [labId]: false }));
    setCurrentSlides(prev => ({ ...prev, [labId]: index }));
    setTimeout(() => setAutoPlay(prev => ({ ...prev, [labId]: true })), 5000);
  };

  return (
    <>
      {/* Hero Banner with Image */}
      <section className={`sgb-hero-banner ${isVisible ? 'sgb-fade-in' : ''}`}>
        <div className="sgb-hero-overlay">
          <div className="sgb-hero-text-content">
            <h1 className="sgb-hero-main-title">Laboratories</h1>
          </div>
        </div>
      </section>

      {/* Main Laboratory Section */}
      <section className="lab-main-section" id="lab-main">
        {/* Header */}
        <div className="lab-header-container">
          <h2 className="lab-page-title">
            STATE-OF-THE-ART <span className="lab-highlight">LABORATORIES</span>
          </h2>
          <p className="lab-page-subtitle">
            Advanced facilities and equipment for hands-on learning and research
          </p>
        </div>

        {/* Laboratories */}
        <div className="lab-items-container">
          {laboratories.map((lab, index) => (
            <div key={lab.id} className={`lab-item lab-item-${lab.order}`}>
              {/* Content Side */}
              <div className="lab-content-side">
                <h3 className="lab-item-title">
                  <img src={lab.icon} alt={lab.name} className="lab-item-icon" />
                  {lab.name}
                </h3>
                <div className="lab-color-bar"></div>
                <p className="lab-item-description">
                  {lab.description}
                </p>
              </div>

              {/* Slider Side */}
              <div className="lab-slider-side">
                <div className="lab-carousel">
                  {/* Images */}
                  <div className="lab-images-wrapper">
                    {lab.images.map((image, imgIndex) => (
                      <div
                        key={imgIndex}
                        className={`lab-image ${imgIndex === currentSlides[lab.id] ? 'lab-image-active' : ''}`}
                      >
                        <img src={image} alt={`${lab.name} ${imgIndex + 1}`} />
                      </div>
                    ))}
                  </div>

                  {/* Navigation Arrows */}
                  <button
                    className="lab-nav-btn lab-nav-prev"
                    onClick={() => prevSlide(lab.id, lab.images.length)}
                    aria-label="Previous"
                  >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="15 18 9 12 15 6"></polyline>
                    </svg>
                  </button>

                  <button
                    className="lab-nav-btn lab-nav-next"
                    onClick={() => nextSlide(lab.id, lab.images.length)}
                    aria-label="Next"
                  >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <polyline points="9 18 15 12 9 6"></polyline>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default Laboratory;